import axios, { type InternalAxiosRequestConfig } from 'axios';

import formatError from './format-error';
import { getCsrfToken, refreshCSRFToken } from './csrf-token-manager';

const axiosInstance = axios.create({
  // baseURL: 'your-api-base-url', // if needed
  withCredentials: true, // bc CSRF token is cookie-based
});

axiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getCsrfToken();
  if (token) {
    config.headers['x-csrf-token'] = token;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.config) return Promise.reject(error);
    const originalRequest = error.config;
    if (!originalRequest._retryCount) {
      originalRequest._retryCount = 0;
    }
    const err = formatError(error);

    if (err.data?.invalidCSRF && originalRequest._retryCount < 3) {
      originalRequest._retryCount++;

      try {
        await refreshCSRFToken();
      } catch (refreshCsrfError) {
        console.error('CSRF token refresh failed:', refreshCsrfError);
        return Promise.reject(refreshCsrfError);
      }

      // Retry original request
      return axiosInstance(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
